import GiftSuccess from "./GiftSuccess";

export default GiftSuccess;
